import React from 'react';
import { DashboardStats } from '@src/components/Dashboard';

export const DashboardPage: React.FC = () => {
  return <DashboardStats />;
};
